import { useCallback, useMemo } from 'react';
import { QUERY_PARAM } from '@config/routing';
import { parseQueryPage } from '@helpers/lists';
import { AppFCC } from '@types';
import { useNavigator } from '@hooks/routing';
import { BUTTON_BASE_COLORED_COLOR } from '@kit/buttons/button-base-colored';
import { LoadMoreButtonWidgetStyled } from './styled';
import { LoadMoreButtonWidgetProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const LoadMoreButtonWidget: AppFCC<LoadMoreButtonWidgetProps> = props => {
  const {
    className,
    children,
    totalCount,
    pageSize = 10,
    onClick
  } = props;
  const navigator = useNavigator();
  const firstPage = 1;
  const totalPages = useMemo(() => Math.ceil(totalCount / pageSize) || 1,
  //
  [pageSize, totalCount]);
  const click = useCallback(() => {
    const query = navigator.getQuery();
    const page = parseQueryPage(query) ?? firstPage;
    const nextPage = page + 1;
    navigator.navigateQuery({
      [QUERY_PARAM.PAGE]: String(nextPage),
      [QUERY_PARAM.KEEP_RESULTS]: String(true)
    });
    onClick?.({
      page: nextPage,
      totalPages
    });
  }, [navigator, onClick, totalPages]);
  return _jsx(LoadMoreButtonWidgetStyled //
  , {
    className: className,
    color: BUTTON_BASE_COLORED_COLOR.PINK,
    onClick: click,
    children: children
  });
};